/* unplugin-vue-components disabled */import script from "./Logo.vue?vue&type=script&setup=true&lang=js"
export * from "./Logo.vue?vue&type=script&setup=true&lang=js"

import "./Logo.vue?vue&type=style&index=0&id=65a86fe5&lang=scss&scoped=true"

import exportComponent from "D:\\phpstudy_pro\\WWW\\www.changshun.com\\web\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-65a86fe5"]])

export default __exports__